import Vue from 'vue'
import PaymentMediasService from 'js/services/api/passenger/payment-medias.js'
import BillingTransactionsService from 'js/services/api/billing/transactions.js'
import RechargesWhitelistService from 'js/services/api/billing/recharges-whitelist.js'
import Transaction from './_transaction.js'

import MediaPanelsCommonMixin from '../_media_panels_common_mixin'

import template from './index.pug'

const TSC_MEDIA_TYPE = 1

// @vue/component
export default {
  template: template(),
  components: {Transaction},
  mixins: [
    MediaPanelsCommonMixin
  ],
  props: {
    tsc: {
      type: Object,
      required: true
    },

    mediaProfiles: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      alias: '',
      prechargesAmount: null, // Saldo pendiente lista blanca
      pendingAmount: null, // Saldo pendiente Everilion
      data: {...this.tsc}, // Objeto para mostrar los cambios de la TSC
      transactions: [],
      aliasPlaceholder: Vue.i18n.t('balance.alias.placeholder'),
      editingAlias: false,
      CardSerialNumber: null,
      errors: {},
      pagination: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      }
    }
  },
  computed: {
    // La TSC no tiene transacciones
    noTransactions() {
      return this.transactions.length === 0
    },

    // Primera transacción del medio
    firstTransaction() {
      return this.noTransactions ? undefined : this.transactions[0]
    },

    // Saldo de la TSC
    balance() {
      return this.tsc.Balance
    },

    pendingTravels() {
      return (this.data || {}).pending_travels
    }
  },
  created() {
    this.alias = this.tsc.alias || this.aliasPlaceholder
    this.getData()
  },
  methods: {
    async getData() {
      await this.getTscTransactions(this.data.mediaCode)
      this.pendingAmount = await this.getPendingAmount(this.data, 1)
      this.prechargesAmount = await this.getPrechargeAmount(this.data)
    },

    /*
     * Transacciones
     */
    getTscTransactions(mediaCode) {
      const params = {
        media_code: mediaCode,
        media_type: TSC_MEDIA_TYPE,
        tsc_client_transactions: true,
        order_by: 'operation_date',
        order_dir: 'desc',
        administrative_area_id: this.administrativeArea.id,
        per: 50
      }

      return BillingTransactionsService.index(params).then(data => {
        this.transactions = this.prepareTscTransactions(data)
        const firstPosition = (this.pagination.currentPage - 1) * this.pagination.limit
        this.pagination.totalElements = this.transactions.length
        this.transactions = this.transactions.slice(firstPosition, firstPosition + this.pagination.limit)
      })
    },

    prepareTscTransactions(transactions) {
      const TZ = this.administrativeArea.time_zone

      if (TZ) {
        _.each(transactions, transaction => {
          const date = moment(transaction.operation_date).tz(TZ)
          transaction.date = date.format('DD MMM HH:mm').replace('.', '')
        })
      }

      return transactions
    },

    async getPrechargeAmount(paymentMedia) {
      const params = {
        media_code: paymentMedia.mediaCode,
        administrative_area_code: this.administrativeArea.code
      }

      return RechargesWhitelistService.index(params, true).then(
        data => data.reduce(this.reducer, 0)
      )
    },

    reducer(sum, recharge) {
      return sum + recharge.recharge_amount
    },

    /*
     * Alias
     */
    async updateAlias() {
      this.errors = {}

      const params = {
        alias: !this.alias || this.alias.trim() === '' ? this.aliasPlaceholder : this.alias
      }

      try {
        const response = await PaymentMediasService.update(this.tsc.id, params)

        if (response.status === 204) {
          Vue.notifications.send({
            id: 'payment-medias-update-success',
            text: Vue.i18n.t('balance.alias.notifications.success'),
            type: 'success',
            close: true
          })

          this.editingAlias = false

          this.alias = params.alias
        }
      } catch (e) {
        this.errors = e

        Vue.notifications.send({
          id: 'payment-medias-update-error',
          text: Vue.i18n.t('balance.alias.notifications.error'),
          type: 'error',
          close: true
        })
      }

      this.aliasUpdated()
    },

    aliasUpdated() {
      this.$emit('alias-updated')
    },

    currencyFilter(amount) {
      return Vue.options.filters.moverickCurrency(amount)
    },

    changeLimit(limit) {
      this.pagination.limit = limit
      this.pagination.currentPage = 1
      this.getData()
    },

    changePage(page) {
      this.pagination.currentPage = page
      this.getData()
    },

    toggleEditingAlias() {
      this.editingAlias = !this.editingAlias
    },
  }
}
